import React from 'react';
import './view-selected-share.scss';
import {
  getSelectedProducts,
  ProductCardVariant,
  useAppSelector,
} from '@zonofi/zono-money-store';
import { ProductCard } from '../product-card/product-card';
import { SVGS } from '../../assets';
import { SELLER_WEBAPP_SHARE_ROUTES } from '../../constants';
import { useNavigate } from 'react-router-dom';

interface ViewShareSelectedProps {}

export const ViewSelectedShare: React.FC<ViewShareSelectedProps> = () => {
  const navigate = useNavigate();
  const selectedProducts = useAppSelector(getSelectedProducts);

  return (
    <div className="view-selected-share">
      <div className="view-selected-share-pdf-header">
        <div className="view-selected-share-pdf-header-content">
          <img src={SVGS.PdfIcon} alt="pdf-icon" width={24} height={24} />
          <span className="view-selected-share-pdf-header-content-text font-bold">
            Share as PDF
          </span>
        </div>
      </div>
      <div className="view-selected-share-header">
        <img src={SVGS.Products} alt="products-icon" />
        <span className="view-selected-share-header-text font-bold">
          {selectedProducts?.length} items
        </span>
      </div>
      <div className="view-selected-share-wrapper">
        <div className="view-selected-share-wrapper-content">
          {selectedProducts?.map((product) => {
            return (
              <ProductCard
                key={product.id}
                variant={ProductCardVariant.VIEW_PRODUCT}
                product={product}
              />
            );
          })}
        </div>
      </div>
      {selectedProducts.length > 0 && (
        <div className="view-selected-share-footer">
          <div
            className="view-selected-share-footer-btn"
            onClick={() => {
              navigate(SELLER_WEBAPP_SHARE_ROUTES.SELECT_SHARE_TEMPLATE);
            }}
          >
            <span className="view-selected-share-footer-btn-text font-semibold">
              Select Template
            </span>
          </div>
        </div>
      )}
    </div>
  );
};
